import React from 'react';
import './view.css';

export default function View({children, className, style}) {
    return (
        <div className={['chitalib-view', className].join(' ')} style={style}>
            {children}
        </div>
    )
}